import React from "react";
import { Box } from "rebass";
import styled from "styled-components";

const Main = styled(Box)``;

Main.defaultProps = {
  is: "main",
  w: "100%",
};

const MainFinal = (props) => (
  <Main>
    <div id="maincontent" tabIndex={-1} />
    {props.children}
  </Main>
);

export default MainFinal;



// WEBPACK FOOTER //
// ./src/components/Main.js